import * as React from 'react'
import { ActivityIndicator, Text, TextStyle, TouchableOpacity, View, ViewStyle } from 'react-native'

import { styles } from './styles'

interface CommonButtonProps {
  name: string
  onPress: () => void
  disabled?: boolean
  loading?: boolean
  textStyle?: TextStyle
  btnStyle?: ViewStyle
}

/**
 *
 * This component is a HOC over the built-in React Native one.
 */
export const CommonButton = (props: CommonButtonProps) => {
  const { name, onPress, loading, btnStyle, textStyle } = props

  return (
    <TouchableOpacity disabled={false} onPress={onPress} style={[styles.buttonStyle, { ...btnStyle }]}>
      <View style={styles.buttonView}>
        <Text allowFontScaling={false} style={[styles.buttonText, { ...textStyle }]}>
          {name}
        </Text>
        {loading ? <ActivityIndicator size="small" color="#FFFFFF" style={styles.loadingStyle} /> : null}
      </View>
    </TouchableOpacity>
  )
}
